function setEvents(data) {
	return {
		type: 'SET_EVENTS',
		payload: data,
	};
}

export { setEvents };
